import React from 'react';
import {FormControl, MenuItem, OutlinedInput, Select} from '@material-ui/core';

export const CustomSelect = ({title, values, value, setValue}) => (
  <FormControl
    variant="outlined"
    style={{
      width: 220,
      marginRight: 10,
    }}>
    <Select
      value={value}
      onChange={event => setValue(event.target.value)}
      displayEmpty
      input={
        <OutlinedInput
          style={{
            borderRadius: 12,
          }}
        />
      }
      style={{
        background: '#fff',
        borderRadius: 40,
      }}
      renderValue={selected => {
        if (!selected) {
          return <span style={{color: '#999'}}>{title}</span>;
        }

        const selectedOption = values.find(item => item.value === selected);

        return selectedOption?.label || selected;
      }}>
      <MenuItem disabled value="">
        {title}
      </MenuItem>

      {values.map(v => (
        <MenuItem key={v.value} value={v.value}>
          {v.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
